module.exports = __webpack_public_path__ + "img/icon-stockpicker-calculating-done@3x.71982dba.png";